module.exports = __webpack_public_path__ + "static/media/icon-Settings.ff6946f6.svg";